export default function SciPy_Optimizers() {
  return (
    <div>
      <h1>SciPy Optimizers</h1>
    </div>
  );
}
